var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2454_141412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49988 4.50012V6.50012M6.49988 8.50012H6.50488M5.80754 1.94598L1.69509 9.04929C1.46699 9.44328 1.35294 9.64028 1.3698 9.80196C1.3845 9.94299 1.45838 10.0711 1.57306 10.1545C1.70454 10.2501 1.93217 10.2501 2.38744 10.2501H10.6123C11.0676 10.2501 11.2952 10.2501 11.4267 10.1545C11.5414 10.0711 11.6153 9.94299 11.63 9.80196C11.6468 9.64028 11.5328 9.44328 11.3047 9.04929L7.19222 1.94598C6.96493 1.55339 6.85129 1.3571 6.70303 1.29118C6.5737 1.23367 6.42606 1.23367 6.29673 1.29118C6.14846 1.3571 6.03482 1.55339 5.80754 1.94598Z",
    stroke: "#DC6803",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2454_141412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alertIcon.6432b9867261de19411cdbb0edcc8b9a.svg";
export { ForwardRef as ReactComponent };